export default {
	section_banner: {
		title: {
			one: '仕事',
			two: '支払い',
		},
		main_title: {
			one: '＆資金調達',
			two: 'アクセス',
		},
		paragraph: {
			one: '資金を効率的に送金、支出、移動、管理することで、当社とのビジネス取引が簡素化されます。',
		},
		cta_buttons: {
			one: 'Get Started',
			two: 'Contact Sales Dept',
		},
	},

	question_sec: {
		label: 'ビジネス用途のJPWorldPayについて学ぶ',
		title: {
			one: '高度な',
			two: 'カスタマイズ可能',
			three: 'コマーシャル',
			four: '解決',
			five: 'あなたのために',
			six: '仕事？',
		},
		cta_buttons: {
			one: '当社の事業について',
		},
	},

	advantage_sec: {
		label: 'オンラインで支払う',
		title: {
			one: '購入',
			two: '便利に',
		},
		paragraph:
			'JPWorldPayの残高は、オンライン決済や直接取引の手数料のお支払いにご利用いただけます。デジタル決済、サービス料金の決済、ベンダーへの支払い管理など、JPWorldPayはあらゆるニーズを迅速かつ安全、そして便利に処理します。',
	},

	advntage_btm_inn_dwn_1st: {
		label: '支払いオプション',
		title: 'お金を払うだけなら',
		paragraph: {
			one: '送金にかかる時間と手間を節約 ',
			two: '電子的に',
		},
		cta_buttons: {
			one: '転送方法',
		},
	},

	advntage_btm_inn_dwn_2nd: {
		label: '受け入れられた支払い',
		title: '支払いをする',
		paragraph: {
			one: '複数の人や場所に簡単に送信できます ',
			two: '同時に',
		},
		cta_buttons: {
			one: '販売について',
		},
	},

	advntage_btm_inn_dwn_3rd: {
		label: 'すぐに支払いをする',
		title: 'Getting Started Today',
		paragraph: {
			one: 'JPWorldPayを利用する販売者に加わりましょう。受け入れを開始 ',
			two: '支払いも早く。',
		},
		cta_buttons: {
			one: '一緒に参加しましょう',
		},
	},

	charging_sec: {
		label: '知っておくべきことすべて',
		title: {
			one: '使用方法、特典、アカウント',
			two: '要件',
		},
		paragraph: {
			one: 'JPWorldPay で資金を維持および使用するには、JPWorldPay ビジネス アカウントまたは JPWorldPay 残高アカウントが必要です。',
			two: 'JPWorldPay Business Debit BlockChainをご購入いただくと、ボーナスキャッシュバックを受け取れる取引は以下のとおりです。お客様が署名し、ブロックチェーンカードで処理されたクレジット取引、現金引き出し、キャッシュサービスとして処理された取引、またはキャッシュバック特典のないPINを使用した取引。',
			three:
				'JPWorldPayビジネスデビットブロックチェーン JPWorldPayが発行します。このカードはJPWorldPayが利用可能な場所であればどこでもご利用いただけます。当社はカード発行会社であり、関連するアカウントやその他の製品、サービス、または提案については一切責任を負いません。',
		},
		cta_buttons: {
			one: '始めましょう',
		},
	},

	section_newsletter: {
		label: 'ニュースレターを購読する',
		title: {
			one: '購読する',
			two: '最新情報を入手',
		},
		description: {
			one: '購読して、オファーや最新情報をメールボックスに直接受け取りましょう。',
			two: '当社の JPWorldPay ソリューションが貴社のビジネスをどのように拡大できるかについて詳しくは、お問い合わせください。',
		},
		form: {
			placeholder: 'メールID',
			button: '今すぐ購読する',
		},
	},
};
